import cx from 'classnames'
import React from 'react'

import SVG from '@cinch/oxd-components/svg/src'
import tokens from '@cinch/oxd-utils/tokens/src/tokens'

import * as styles from './header-icon.module.css'

const { spacing } = tokens.customProperties

export enum Theme {
  light = 'light',
  dark = 'dark',
}

export interface HeaderIcon extends Partial<Pick<HTMLButtonElement, Exclude<keyof HTMLButtonElement, 'children'>>> {
  svg?: string
  hasLabel?: boolean
  isActive?: boolean
  theme: Theme
  onClick?: () => void
  label?: string
}

export const getThemeStyle = (theme: Theme) => {
  switch (theme) {
    case Theme.dark:
      return styles.themeDark
    case Theme.light:
      return styles.themeLight
  }
}

const HeaderIconComponent: React.FC<HeaderIcon> = ({
  svg,
  children,
  isActive,
  theme,
  hasLabel,
  onClick,
  label,
  ...props
}) => {
  const themeClass = getThemeStyle(theme)

  return (
    <button
      onClick={onClick}
      aria-label={label}
      title={label}
      type="button"
      className={cx(
        styles.buttonBase,
        themeClass,
        {
          [styles.active]: isActive,
        },
        props.className,
      )}
    >
      {svg ? <SVG size={spacing.xl}>{svg}</SVG> : children ? children : null}
      {hasLabel && <span>{label}</span>}
    </button>
  )
}

HeaderIconComponent.defaultProps = {
  isActive: false,
  hasLabel: false,
  theme: Theme.light,
}

export default HeaderIconComponent
